<template>
  <div>
    <sub-main/>
  </div>
</template>
<script>
import SubMain from '../../canads/casas/maplocation/SubMain'
export default {
  name: "SubMenu",
  components: {
    SubMain
  }
}
</script>
<style scoped>
</style>